import React from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { ButtonComponent } from '../ui';

const LogOutModal = ({ show, handleClose, handleConfirm }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-700/40 dark:bg-black/60 backdrop-blur-sm z-50 admin-global-fontfamily-description">
      <div className="bg-app-card border border-app-primary rounded-lg p-6 text-center w-[90%] max-w-md shadow-lg dark:shadow-black/50">
        <div className="flex justify-center mb-4">
          <FaSignOutAlt className="text-red-600 dark:text-red-500 text-[40px]" />
        </div>
        <h4 className="font-bold text-xl mb-6 text-app-heading">Are You Sure?</h4>
        <div className="flex justify-around">
          {/* <button
            className="w-[100px] h-[40px] rounded-md bg-gray-200 hover:bg-gray-300"
            onClick={handleClose}
          >
            Cancel
          </button> */}
          <ButtonComponent
            color="gray"
            onClick={handleClose}>
            Cancel
          </ButtonComponent>
          {/* <button
            className="w-[100px] h-[40px] rounded-md bg-red-600 text-white hover:bg-red-700"
            onClick={handleConfirm}
          >
            Log Out
          </button> */}
          <ButtonComponent
            color="red"
            onClick={handleConfirm}>
            Log Out
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
};

export default LogOutModal;
